import React from 'react';
import { Network } from 'lucide-react';

/**
 * Service allocations: gateway/SMS keys live under API Settings (super_admin).
 * Operators are routed there to avoid duplicate forms and client-secret sprawl.
 */
const AllocationsManager = ({ role, onNavigate }) => {
  return (
    <div className="p-6 space-y-6">
      <div className="bg-white rounded-lg border p-6">
        <div className="flex items-center gap-3 mb-2">
          <Network className="w-5 h-5 text-orange-600" />
          <h2 className="text-xl font-semibold">Service allocations</h2>
        </div>
        <p className="text-gray-600 text-sm mb-4">
          Payment gateway, SMS, and related provider configuration is centralized in <strong>API Settings</strong>.
          Writes should remain server-side where possible; use this entry point for operational routing only.
        </p>
        {role === 'super_admin' ? (
          <div className="space-y-3">
            <button
              type="button"
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              onClick={() => onNavigate?.('api-settings')}
            >
              Open API Settings
            </button>
            <p className="text-xs text-gray-500">
              After rotating keys, verify webhooks and test a sandbox payment before production traffic.
            </p>
          </div>
        ) : (
          <p className="text-sm text-amber-800 bg-amber-50 border border-amber-200 rounded p-3">
            Super admin role required to edit API allocations. Contact a super admin for changes.
          </p>
        )}
      </div>
    </div>
  );
};

export default AllocationsManager;
